export const symbolMap: Record<string, string> = {
  // Additional Greek/math-related special symbols
  aleph: 'ALEPH',
  hbar: 'HBAR',
  jmath: 'JMATH',
  imath: 'IMATH',
  wp: 'WP',
  vartheta: 'vartheta',
  varupsilon: 'varupsilon',
  ohm: 'OHM',
  imag: 'IMAG',
  varpi: 'varpi',
  varphi: 'varphi',
  angstrom: 'ANGSTROM',
  varsigma: 'varsigma',
  varepsilon: 'varepsilon',

  // Set/union symbols
  ll: '<<',
  gg: '>>',
  lll: 'LLL',

  // Miscellaneous symbols (corrected)
  measuredangle: 'MSANGLE',
  sphericalangle: 'SANGLE',
  degree: 'DEG',
  fahrenheit: 'FAHRENHEIT',
  backslash: 'LSLANT',
  slash: 'RSLANT',
  percento: 'hund',
  percentoo: 'thou',
  triangle: 'TRIANGLE',
  triangledown: 'TRIANGLED',

  // Arrow symbols
  leftarrow: 'larrow',
  rightarrow: 'rarrow',
  to: 'rarrow',
  uparrow: 'uparrow',
  downarrow: 'downarrow',
  Leftarrow: 'LARROW',
  Rightarrow: 'RARROW',
  Uparrow: 'UPARROW',
  Downarrow: 'DOWNARROW',
  updownarrow: 'udarrow',
  leftrightarrow: 'lrarrow',
  Leftrightarrow: 'LRARROW',
  hookleftarrow: 'hookleft',
  hookrightarrow: 'hookright',

  //big operators
  bigcap: 'INTER',
  int: 'int',
  iint: 'dint',
  iiint: 'tint',
  sum: 'sum',
  lim: 'lim',


  '\|' : '∥',

  left : '',
  right:'',
};